var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMinusCircleFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 21.9976C17.5214 21.9976 21.9974 17.5215 21.9974 12.0001C21.9974 6.4786 17.5214 2.00256 11.9999 2.00256C6.47847 2.00256 2.00244 6.4786 2.00244 12.0001C2.00244 17.5215 6.47847 21.9976 11.9999 21.9976Z",
    fill: "#EDF4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9997 21.4421C17.2144 21.4421 21.4418 17.2148 21.4418 12.0001C21.4418 6.78535 17.2144 2.55798 11.9997 2.55798C6.78498 2.55798 2.55762 6.78535 2.55762 12.0001C2.55762 17.2148 6.78498 21.4421 11.9997 21.4421Z",
    stroke: "#29398E"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.25,
    y1: 12.25,
    x2: 15.75,
    y2: 12.25,
    stroke: "#293990",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusCircleFill);
export default __webpack_public_path__ + "static/media/minus-circle-fill.5fb63975420bd9c5a1c334d7171532c5.svg";
export { ForwardRef as ReactComponent };